
import ListItemVue from "@/components/common/ListItem.vue";
import { ListItem } from "@/models/common";
import { IFacility } from "@/models/facility";
import { defineComponent, PropType, reactive } from "vue";

export default defineComponent({
  props: {
    hospitals: {
      type: Object as PropType<IFacility>,
      required: true,
    },
    isDefaultDetail: {
      type: Boolean,
      default: true,
    },
  },
  name: "doctor item",
  setup(props) {
    const state = reactive({
      hospitals: new ListItem().HospitalItemToListItem(props.hospitals),
      isDefaultDetail: props.isDefaultDetail,
    });

    return {
      state,
    };
  },
  components: {
    ListItemVue,
  },
});
